export default __webpack_public_path__ + "static/media/SliderProducts3.51175a8b.mp4";